module.exports = __webpack_public_path__ + "static/img/zhuceyouli.06f2c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/zhuceyouli.png
// module id = R2QU
// module chunks = 69